import { API } from "aws-amplify";

import { initData } from "utils/utilAmplify";
import { generateErrorResponse } from "utils/helpers";
import { IMatchesEnum } from "interfaces/intarfaces";

export const HostAPI = {
  get: async (path: string = "") => {
    try {
      return await API.get("HostMatches", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  post: async (path: string = "", body: IMatchesEnum) => {
    try {
      return await API.post("StudentMatches", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
};
